<script lang="ts" setup>
  defineProps<{ roundsUntilIChoose: null | number }>();
</script>

<template>
  <p v-if="roundsUntilIChoose !== null" class="rounds-until-i-choose">
    <template v-if="roundsUntilIChoose === 1">Get ready, you are choosing next round!</template>
    <template v-else>{{ roundsUntilIChoose }} rounds until you choose a song</template>
  </p>
</template>

<style scoped>
  .rounds-until-i-choose {
    color: var(--color-primary);
    font-size: var(--font-size-md);
    letter-spacing: 0.05em;
    margin: 0;
    text-align: center;
    text-transform: uppercase;
  }
</style>
